import { Currency, ETHER, Token } from '@wanswap/sdk'
import React, { useMemo } from 'react'
import styled from 'styled-components'

import EthereumLogo from '../../assets/images/wanchain-logo.png'
import useHttpLocations from '../../hooks/useHttpLocations'
import { WrappedTokenInfo } from '../../state/lists/hooks'
import Logo from '../Logo'

export const getTokenLogoURL = (address: string) =>
  (`https://icons.wanswap.finance/tokens/${address}.png`).toLowerCase()

const StyledEthereumLogo = styled.img<{ size: string }>`
 
  height: ${({ size }) => size};
  margin-right:-3px;
`

const StyledLogo = styled(Logo)<{ size: string }>`
 
  height: ${({ size }) => size};
  margin-right:-3px;
  
`

export default function CurrencyLogo({
  currency,
  size = '24px',
  style
}: {
  currency?: Currency
  size?: string
  style?: React.CSSProperties
}) {
  const uriLocations = useHttpLocations(currency instanceof WrappedTokenInfo ? currency.logoURI : undefined)

  const srcs: string[] = useMemo(() => {
    if (currency === ETHER) return []

    if (currency?.symbol === 'WASP') {
      if (currency?.name === 'WASP_V2') {
        return [require('../../assets/images/wanswapv2-icon.png')]
      }
      return [require('../../assets/images/wanswap-icon.png')]
    }

    if (currency instanceof Token) {
      if (currency instanceof WrappedTokenInfo) {
        return [...uriLocations, getTokenLogoURL(currency.address)]
      }

      return [getTokenLogoURL(currency.address)]
    }
    return []
  }, [currency, uriLocations])

  if (currency === ETHER) {
    return <StyledEthereumLogo src={EthereumLogo} size={size} style={style} />
  }

  return <StyledLogo size={size} srcs={srcs} alt={`${currency?.symbol ?? 'token'} logo`} style={style} />
}
